var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lines-bg pt-20 pb-12 lg:pt-40"},[_c('contact-form',{attrs:{"formData":_vm.fields,"formName":"Web Contact","sendKey":"Help With","content":{heading: 'You have questions. We have answers.'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }